module.exports = __webpack_public_path__ + "static/imagem_5-0a09b95b131edcf90788f275222b1e91.jpeg";